<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>User Profile</h5>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <a-spin :spinning="loading">
          <a-form class="mb-4" :form="form">

            <p class="pt-3">Account User Details</p>
            <div class="row">
              <div class="col-md-4">
                <a-form-item label="First name">
                <a-input
                  placeholder="First name"
                  v-decorator="['first_name', {rules: [{ required: true, message: 'Please input user first name!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Last name">
                <a-input
                  placeholder="Last name"
                  v-decorator="['last_name', {rules: [{ required: true, message: 'Please input user last name!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Phone">
                  <a-input
                    placeholder="Phone"
                    v-decorator="['phone', {rules: [{ required: true, message: 'Please input a valid phone!', pattern: new RegExp(`[1-9][0-9]{7,14}`) }]}]"
                    width="100%"
                  >
                  <a-select
                    slot="addonBefore"
                    v-decorator="[
                      'country_code',
                      { initialValue: '91' }
                    ]"
                    style="width: 70px"
                  >
                    <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                      <span class="text-bold">{{countryCode.name}}</span>
                    </a-select-option>
                  </a-select>
                  </a-input>
                </a-form-item>
              </div>

              <div class="col-md-3">
                <a-form-item label="Email">
                  <a-input
                    :disabled="true"
                    placeholder="Email"
                    v-decorator="[
                      'email',
                      {
                        rules: [{
                          type: 'email', message: 'The input is not valid email!',
                        }, {
                          required: true, message: 'Please input an email!',
                        }],
                      }
                    ]"
                  />
                </a-form-item>
              </div>

              <div class="col-md-3">
                <a-form-item label="Password">
                  <a-input
                    v-decorator="[
                      'password',
                      {
                        rules: [{
                          required: false, message: 'Please input a password!',
                        }, {
                          validator: validateToNextPassword,
                        }],
                      }
                    ]"
                    type="password"
                    :disabled="!changePassword"
                  />
                </a-form-item>
                <a-button type="link" @click="changePasswordHandler">Click here to Change password</a-button>
              </div>

              <div class="col-md-3">
                <a-form-item label="Confirm Password">
                  <a-input
                    v-decorator="[
                      'confirm_password',
                      {
                        rules: [{
                          required: false, message: 'Please confirm user password!',
                        }, {
                          validator: compareToFirstPassword,
                        }],
                      }
                    ]"
                    type="password"
                    @blur="handleConfirmBlur"
                    :disabled="!changePassword"
                  />
                </a-form-item>
              </div>

              <div class="col-md-3">
                <a-form-item label="Current Password">
                  <a-input
                    v-decorator="[
                      'current_password',
                      {
                        rules: [{
                          required: false, message: 'Please enter current password!',
                        },],
                      }
                    ]"
                    type="password"
                    :disabled="!changePassword"
                  />
                </a-form-item>
              </div>
            </div>

            <a-divider />
            <div class="row justify-content-between py-3">
              <div class="col-md-4"></div>
              <div class="col-md-4 text-md-right">
                <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Update Profile</a-button>
              </div>
            </div>
          </a-form>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ant-drawer-close-x{
  margin-right: 0.7rem;
}
</style>

<script>
import store from '@/store'
import { omit, mapValues } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import { countryCodes } from '@/services/globaldata'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    if (typeof value === 'object' && value._isAMomentObject === true) {
      return moment(value).format('YYYY-MM-DD')
    }
    return value
  },
}

export default {
  mounted: function() {
    this.getUser()
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      schoolId: this.$store.state.user.user.school.id,
      loading: true,
      logo: null,
      changePassword: false,
      countryCodes,
    }
  },
  computed: mapState(['settings']),
  methods: {
    moment,
    getUser() {
      this.loading = true
      this.spinning = true
      this.$http.get('/api/auth/getuser').then(({ data }) => {
        const userData = omit(data.data, ['id', 'school', 'role', 'school_id', 'deleted_at', 'updated_at', 'created_at', 'password_changed_at', 'status'])
        const fieldsData = mapValues({ ...userData }, function(value) {
          return value !== null ? value : undefined
        })

        this.form.setFieldsValue({ ...fieldsData })
        this.spinning = false
        this.loading = false
      })
    },
    changePasswordHandler () {
      this.changePassword = !this.changePassword
      this.form.resetFields(['user[password]', 'user[confirm_password]'])
    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Not same with the password!')
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },
    handleSubmit(e) {
      this.loading = true

      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update your account details?`,
            content: `Click on the OK button to update!`,
            onOk: () => {
              let formData = window.jsonToFormData(values, options)

              formData.append('_method', 'PATCH')

              this.$http
                .post('/api/auth/updateuser', formData)
                .then(({ data }) => {
                  this.loading = false
                  this.visible = false

                  // Commit to store and local storage
                  localStorage.setItem('user', JSON.stringify(data.data))
                  store.commit('UPDATE_USER', { user: data.data })

                  this.$notification['success']({
                    message: 'User details successfully updated!',
                    description: `Updated successfully!`,
                  })
                  this.fileList = []
                  this.logo = null
                  this.uploadDisabled = false
                  this.getUser()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss">
</style>
